import React from 'react';

import {useOutletContext} from 'react-router-dom';
import {CampaignOutletContextValue} from '../form';
import CreativeStudioPane from './CreativeStudio';
import CreativeStudioEntryPane from './CreativeStudioEntry';

// The `creative` tab route exists in both route trees (/campaigns and /cs-campaigns). Which pane
// it shows follows the campaign's own type, not the route (design D5): creative-studio
// campaigns get the entry pane, standard campaigns the legacy creative-studio pane.
const CreativeTabPane = () => {
    const {values} = useOutletContext<CampaignOutletContextValue>();
    return values?.type === 'creative_studio' ? <CreativeStudioEntryPane/> : <CreativeStudioPane/>;
};

export default CreativeTabPane;
